import { Union } from "../../fable-library-js.4.19.3/Types.js";
import { Common_GenericOptions__AddProp_ZCC5A61F, Color_ofColor, Common_parseOptions, Common_GenericOptions__AddModifiers_Z7C3AFA3, Common_GenericOptions__AddClass_Z721C83C5, Common_GenericOptions__AddProps_Z4E55E0BD, Common_GenericOptions__AddCaseName_1505, Common_GenericOptions_Parse_Z4D1A7726, Common_GenericOptions__ToReactElement_4509C2D7, Modifier_IModifier_$reflection, Color_IColor_$reflection } from "../Common.fs.js";
import { lambda_type, unit_type, bool_type, union_type, string_type, list_type, class_type } from "../../fable-library-js.4.19.3/Reflection.js";
import * as react from "react";
import { keyValueList } from "../../fable-library-js.4.19.3/MapUtil.js";
import { DOMAttr } from "../../Fable.React.9.4.0/Fable.React.Props.fs.js";

export class Option extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Color", "has-shadow", "is-transparent", "is-fixed-top", "is-fixed-bottom", "is-spaced", "Props", "CustomClass", "Modifiers"];
    }
}

export function Option_$reflection() {
    return union_type("Fulma.Navbar.Option", [], Option, () => [[["Item", Color_IColor_$reflection()]], [], [], [], [], [], [["Item", list_type(class_type("Fable.React.IHTMLProp"))]], [["Item", string_type]], [["Item", list_type(Modifier_IModifier_$reflection())]]]);
}

export class Menu_Option extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["is-active", "Props", "CustomClass", "Modifiers"];
    }
}

export function Menu_Option_$reflection() {
    return union_type("Fulma.Navbar.Menu.Option", [], Menu_Option, () => [[["Item", bool_type]], [["Item", list_type(class_type("Fable.React.IHTMLProp"))]], [["Item", string_type]], [["Item", list_type(Modifier_IModifier_$reflection())]]]);
}

export class Burger_Option extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["is-active", "OnClick", "Props", "CustomClass", "Modifiers"];
    }
}

export function Burger_Option_$reflection() {
    return union_type("Fulma.Navbar.Burger.Option", [], Burger_Option, () => [[["Item", bool_type]], [["Item", lambda_type(class_type("Browser.Types.MouseEvent", undefined), unit_type)]], [["Item", list_type(class_type("Fable.React.IHTMLProp"))]], [["Item", string_type]], [["Item", list_type(Modifier_IModifier_$reflection())]]]);
}

export class Item_Option extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["is-tab", "is-active", "is-hoverable", "has-dropdown", "is-expanded", "Props", "CustomClass", "Modifiers"];
    }
}

export function Item_Option_$reflection() {
    return union_type("Fulma.Navbar.Item.Option", [], Item_Option, () => [[], [["Item", bool_type]], [], [], [], [["Item", list_type(class_type("Fable.React.IHTMLProp"))]], [["Item", string_type]], [["Item", list_type(Modifier_IModifier_$reflection())]]]);
}

export function Item_item(element, options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, (result, option) => {
        switch (option.tag) {
            case 4:
            case 0:
            case 2:
            case 3:
                return Common_GenericOptions__AddCaseName_1505(result, option);
            case 5:
                return Common_GenericOptions__AddProps_Z4E55E0BD(result, option.fields[0]);
            case 6:
                return Common_GenericOptions__AddClass_Z721C83C5(result, option.fields[0]);
            case 7:
                return Common_GenericOptions__AddModifiers_Z7C3AFA3(result, option.fields[0]);
            default:
                if (option.fields[0]) {
                    return Common_GenericOptions__AddCaseName_1505(result, option);
                }
                else {
                    return result;
                }
        }
    }, "navbar-item"), element, children);
}

/**
 * Generate <div class="navbar-item"></div>
 */
export function Item_div(x, y) {
    return Item_item((props, children) => react.createElement("div", keyValueList(props, 1), ...children), x, y);
}

/**
 * Generate <a class="navbar-item"></a>
 */
export function Item_a(x, y) {
    return Item_item((props, children) => react.createElement("a", keyValueList(props, 1), ...children), x, y);
}

export class Link_Option extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["is-active", "is-arrowless", "Props", "CustomClass", "Modifiers"];
    }
}

export function Link_Option_$reflection() {
    return union_type("Fulma.Navbar.Link.Option", [], Link_Option, () => [[["Item", bool_type]], [], [["Item", list_type(class_type("Fable.React.IHTMLProp"))]], [["Item", string_type]], [["Item", list_type(Modifier_IModifier_$reflection())]]]);
}

export function Link_link(element, options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, (result, option) => {
        switch (option.tag) {
            case 1:
                return Common_GenericOptions__AddCaseName_1505(result, option);
            case 2:
                return Common_GenericOptions__AddProps_Z4E55E0BD(result, option.fields[0]);
            case 3:
                return Common_GenericOptions__AddClass_Z721C83C5(result, option.fields[0]);
            case 4:
                return Common_GenericOptions__AddModifiers_Z7C3AFA3(result, option.fields[0]);
            default:
                if (option.fields[0]) {
                    return Common_GenericOptions__AddCaseName_1505(result, option);
                }
                else {
                    return result;
                }
        }
    }, "navbar-link"), element, children);
}

/**
 * Generate <div class="navbar-link"></div>
 */
export function Link_div(x, y) {
    return Link_link((props, children) => react.createElement("div", keyValueList(props, 1), ...children), x, y);
}

/**
 * Generate <a class="navbar-link"></a>
 */
export function Link_a(x, y) {
    return Link_link((props, children) => react.createElement("a", keyValueList(props, 1), ...children), x, y);
}

export class Dropdown_Option extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["is-active", "is-boxed", "is-right", "Props", "CustomClass", "Modifiers"];
    }
}

export function Dropdown_Option_$reflection() {
    return union_type("Fulma.Navbar.Dropdown.Option", [], Dropdown_Option, () => [[["Item", bool_type]], [], [], [["Item", list_type(class_type("Fable.React.IHTMLProp"))]], [["Item", string_type]], [["Item", list_type(Modifier_IModifier_$reflection())]]]);
}

export function Dropdown_dropdown(element, options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, (result, option) => {
        switch (option.tag) {
            case 1:
            case 2:
                return Common_GenericOptions__AddCaseName_1505(result, option);
            case 3:
                return Common_GenericOptions__AddProps_Z4E55E0BD(result, option.fields[0]);
            case 4:
                return Common_GenericOptions__AddClass_Z721C83C5(result, option.fields[0]);
            case 5:
                return Common_GenericOptions__AddModifiers_Z7C3AFA3(result, option.fields[0]);
            default:
                if (option.fields[0]) {
                    return Common_GenericOptions__AddCaseName_1505(result, option);
                }
                else {
                    return result;
                }
        }
    }, "navbar-dropdown"), element, children);
}

/**
 * Generate <div class="navbar-dropdown"></div>
 */
export function Dropdown_div(x, y) {
    return Dropdown_dropdown((props, children) => react.createElement("div", keyValueList(props, 1), ...children), x, y);
}

/**
 * Generate <a class="navbar-dropdown"></a>
 */
export function Dropdown_a(x, y) {
    return Dropdown_dropdown((props, children) => react.createElement("a", keyValueList(props, 1), ...children), x, y);
}

export function Brand_brand(element, options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, Common_parseOptions, "navbar-brand"), element, children);
}

/**
 * Generate <div class="navbar-brand"></div>
 */
export function Brand_div(x, y) {
    return Brand_brand((props, children) => react.createElement("div", keyValueList(props, 1), ...children), x, y);
}

/**
 * Generate <a class="navbar-brand"></a>
 */
export function Brand_a(x, y) {
    return Brand_brand((props, children) => react.createElement("a", keyValueList(props, 1), ...children), x, y);
}

export function Start_start(element, options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, Common_parseOptions, "navbar-start"), element, children);
}

/**
 * Generate <div class="navbar-start"></div>
 */
export function Start_div(x, y) {
    return Start_start((props, children) => react.createElement("div", keyValueList(props, 1), ...children), x, y);
}

/**
 * Generate <a class="navbar-start"></a>
 */
export function Start_a(x, y) {
    return Start_start((props, children) => react.createElement("a", keyValueList(props, 1), ...children), x, y);
}

export function End_end(element, options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, Common_parseOptions, "navbar-end"), element, children);
}

/**
 * Generate <div class="navbar-end"></div>
 */
export function End_div(x, y) {
    return End_end((props, children) => react.createElement("div", keyValueList(props, 1), ...children), x, y);
}

/**
 * Generate <a class="navbar-end"></a>
 */
export function End_a(x, y) {
    return End_end((props, children) => react.createElement("a", keyValueList(props, 1), ...children), x, y);
}

/**
 * Generate <nav class="navbar"></nav>
 */
export function navbar(options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, (result, option) => {
        switch (option.tag) {
            case 0:
                return Common_GenericOptions__AddClass_Z721C83C5(result, Color_ofColor(option.fields[0]));
            case 6:
                return Common_GenericOptions__AddProps_Z4E55E0BD(result, option.fields[0]);
            case 7:
                return Common_GenericOptions__AddClass_Z721C83C5(result, option.fields[0]);
            case 8:
                return Common_GenericOptions__AddModifiers_Z7C3AFA3(result, option.fields[0]);
            default:
                return Common_GenericOptions__AddCaseName_1505(result, option);
        }
    }, "navbar"), (props_1, children_1) => react.createElement("nav", keyValueList(props_1, 1), ...children_1), children);
}

/**
 * Generate <div class="navbar-menu"></div>
 */
export function menu(options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, (result, option) => {
        switch (option.tag) {
            case 1:
                return Common_GenericOptions__AddProps_Z4E55E0BD(result, option.fields[0]);
            case 2:
                return Common_GenericOptions__AddClass_Z721C83C5(result, option.fields[0]);
            case 3:
                return Common_GenericOptions__AddModifiers_Z7C3AFA3(result, option.fields[0]);
            default:
                if (option.fields[0]) {
                    return Common_GenericOptions__AddCaseName_1505(result, option);
                }
                else {
                    return result;
                }
        }
    }, "navbar-menu"), (props_1, children_1) => react.createElement("div", keyValueList(props_1, 1), ...children_1), children);
}

/**
 * Generate <div class="navbar-burger"></div>
 */
export function burger(options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, (result, option) => {
        switch (option.tag) {
            case 1:
                return Common_GenericOptions__AddProp_ZCC5A61F(result, new DOMAttr(40, [option.fields[0]]));
            case 2:
                return Common_GenericOptions__AddProps_Z4E55E0BD(result, option.fields[0]);
            case 3:
                return Common_GenericOptions__AddClass_Z721C83C5(result, option.fields[0]);
            case 4:
                return Common_GenericOptions__AddModifiers_Z7C3AFA3(result, option.fields[0]);
            default:
                if (option.fields[0]) {
                    return Common_GenericOptions__AddCaseName_1505(result, option);
                }
                else {
                    return result;
                }
        }
    }, "navbar-burger"), (props_1, children_1) => react.createElement("div", keyValueList(props_1, 1), ...children_1), children);
}

/**
 * Generate <div class="navbar-content"></div>
 */
export function content(options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, Common_parseOptions, "navbar-content"), (props, children_1) => react.createElement("div", keyValueList(props, 1), ...children_1), children);
}

/**
 * Generate <div class="navbar-divider"></div>
 */
export function divider(options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, Common_parseOptions, "navbar-divider"), (props, children_1) => react.createElement("div", keyValueList(props, 1), ...children_1), children);
}

